<template>
  <div class="NoticeDialog">
    <el-container class="p-0">
      <el-main>
        <table class="border w-full">
          <col width="80px" />
          <col />
          <tr>
            <th>제 목</th>
            <td>{{current.title}}</td>
          </tr>
          <tr>
            <th>내 용</th>
            <td class="content"><pre>{{current.content}}</pre></td>
          </tr>
          <tr>
            <th>게 시</th>
            <td>
              {{current.begin_date}} ~ {{current.end_date}}
            </td>
          </tr>
          <tr>
            <th>부 서</th>
            <td>{{resolveBranch}}</td>
          </tr>
          <tr>
            <th>그 룹</th>
            <td>{{resolveUserGroup}}</td>
          </tr>
        </table>
      </el-main>
      <el-footer>
        <el-button 
          icon="el-icon-arrow-left"
          :disabled="disablePrev"
          @click="handleClickPrev"
        >이전</el-button>
        <el-button
          :disabled="disableNext"
          @click="handleClickNext"
        >다음<i class="el-icon-arrow-right"/></el-button>
        <el-button 
          class="close-button" 
          @click="handleClickClose"
        >{{$t('button.close')}}(Esc)</el-button>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Notice",
  data() {
    return {
      title: this.$t('title.notice'),
      current: {
        title: '',
        content: '',
        begin_date: '',
        end_date: '',
      },
    };    
  },  
  props: {
    data: {
      type: Object,
      required: true
    }
  },  
  computed: {
    ...mapGetters(["table_branch", "table_user_group", "table_notice"]),
    resolveBranch() {
      if (this.current.branch_all_flag === 'Y') {
        return '전체'
      } else if (!this.current.branch_ids) {
        return ''
      } else {
        let result = "";
        this.current.branch_ids.forEach(id => {
          let branch = this.table_branch.find(b => b.id === id);
          if (result.length > 0) {
            result += ", ";
          }
          result += branch.name;
        });
        return result;
      }
    },
    resolveUserGroup() {
      if (this.current.user_group_all_flag === 'Y') {
        return '전체'
      } else if (!this.current.user_group_ids) {
        return ''
      } else {
        let result = "";
        this.current.user_group_ids.forEach(id => {
          let group = this.table_user_group.find(g => g.id === id);
          if (result.length > 0) {
            result += ", ";
          }
          result += group.name;
        });
        return result;
      }
    },
    currentIndex() {
      return this.table_notice.findIndex(n => n.id === this.current.id)
    },
    disablePrev() {
      let index = this.currentIndex;
      return index <= 0;
    },
    disableNext() {
      let index = this.currentIndex;
      return index + 1 >= this.table_notice.length;
    },
  },
  watch: {
    data(data){
      this.current = data;
      this.updateRead();
    }
  },
  methods: {
    ...mapActions(['saveLocalDb']),
    updateRead() {
      if (!this.current) { return; }
      this.api.updateNoticeLog(this.current).then(res => {
        if (res.error !== this.system.noError) { return; }
        this.current.read_flag = 'Y';
        this.saveLocalDb({'table': 'table_notice', 'data': this.current});
      });
    },
    handleClickClose() {
      this.$emit('completed')
    },
    handleClickPrev() {
      let index = this.currentIndex;
      this.current = this.table_notice[index - 1]
      this.updateRead();
    },
    handleClickNext() {
      let index = this.currentIndex;
      this.current = this.table_notice[index + 1]
      this.updateRead();
    },
  }
};
</script>
<style lang="scss">
@import "@/assets/css/_variables.scss";
.NoticeDialog {
  table {
    tr {
      height: 25px;
      th {
        background-color: $color-primary;
        color: white;
      }    
      td {
        padding-left: 10px;;
        text-align: left;
        &.content {
          height: 200px;   
          vertical-align: top;     
        }  
      }    
    }
  }
}
</style>